import React from "react";
import DOMPurify from "dompurify";

export default function RenderedHtml({ html }) {
  return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />;
}
